<template>
  <div>
    <div
      class="mb-3"
      v-for="(review,r) in rawMenu.user.reviews"
      :key="r"
    >
      <h4 class="h5 mb-1">{{ review.source }}</h4>
      <span class="small  mr-2">{{ review.rating }}</span><i
        v-if="review.rating>=1"
        class="fas fa-star"
      ></i>

      <i
        v-if="review.rating>1 && review.rating<2"
        class="fas fa-star-half-alt"
      ></i>
      <i
        v-if="review.rating==0"
        class="far fa-star"
      ></i>
      <i
        v-if="review.rating>=2"
        class="fas fa-star"
      ></i>
      <i
        v-if="review.rating>2 && review.rating<3"
        class="fas fa-star-half-alt"
      ></i>
      <i
        v-if="review.rating==1"
        class="far fa-star"
      ></i>
      <i
        v-if="review.rating>=3"
        class="fas fa-star"
      ></i>

      <i
        v-if="review.rating>3 && review.rating<4"
        class="fas fa-star-half-alt"
      ></i>
      <i
        v-if="review.rating==2||review.rating<1"
        class="far fa-star"
      ></i>
      <i
        v-if="review.rating>=4"
        class="fas fa-star"
      ></i>
      <i
        v-if="review.rating==3||review.rating<2"
        class="far fa-star"
      ></i>
      <i
        v-if="review.rating>4 && review.rating<5"
        class="fas fa-star-half-alt"
      ></i>
      <i
        v-if="review.rating==4||review.rating<3"
        class="far fa-star"
      ></i>
      <i
        v-if="review.rating==5"
        class="fas fa-star"
      ></i><span
        class="ml-2 small text-muted"
        v-if="review.count"
      >{{ review.count }} reviews</span>
      <div
        v-if="review.quotes"
        class="mt-2"
      >
        <div
          v-for="(quote,q) in review.quotes"
          :key="q"
        >
          - {{ quote.quote }}
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
